import {
  Injectable
} from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { ApiService } from './api.service';
// import { TenantApiService } from './modules/tenant-config/services/tenant-api.service';


@Injectable({
  providedIn: "root"
})
export class PermissionsToRoutes {
  user:any;

  $userPermissions: ReplaySubject<string[]> = new ReplaySubject(1);

  redirectAfterLogin:string = 'test'

  constructor(private apiService:ApiService, ){ 
    this.setPer()
      
    }
    
  get userPermissions()
  {
    return this.$userPermissions.asObservable().pipe(take(1)).toPromise()
  }

  setPer()
  {  
    
    return new Promise<void>((re)=>{
      this.apiService.getUser().subscribe((p: any) => {   
        this.user = p   
        this.$userPermissions.next(p.isSuperAdmin ? ['isSuperAdmin'] : ['user'])
        re()
      }, err => {
        this.user = null
        this.$userPermissions.next([])
      })

    })
  }

  getPerFroServer()
  {
    return this.apiService.getUser()
  }

  settings:Per = {
      per:["isSuperAdmin"]
  }

  home:Per = {

    per:[],

    "file/:id":{
      per:[]
    },

    "filter/:id":{
      per:[]
    },

    "login":{
      per:[]
    },
  }
  
  "test/:id":Per = {
    per:['user','isSuperAdmin']
  }

  

 
  async hasPermissions(urlPath:string[])
  {
    let courrentRout:any = this
    
    for(let route of urlPath)
    {
      console.log(route);
      
        courrentRout = courrentRout[route]
        if((courrentRout && !courrentRout.per.length)||!courrentRout)
          continue

        if( !await this.permissionsInUser(courrentRout.per))
        {
            // alert("you Don't have permissions for this URL");
            this.apiService.emitRespons.next({massege:"בשביל  לבצע מבחן צריך להיות מחוברים",status:"err"})

            return false;

        }
    }
    return true
  }

  async permissionsInUser(permissions:string[])
  {
  
    
    let userPermissions:any = await this.userPermissions

    for(let per of permissions)
    {
        if(userPermissions.includes(per))
            return true
    }
    return false

  }

}

interface Per {
  [key: string]: any
}
